import React, { useState }    from 'react';
import { connect }            from 'react-redux';
import { Auth }               from 'aws-amplify';

import validator from 'validator'
import FormValidator from '../../../modules/FormValidator';

import { getCurrentUser } from '../../../redux/actions/user';
import { setCognitoUser } from '../../../redux/actions/cognitoUser';

import Checkbox         from '@material-ui/core/Checkbox';
import Grid             from '@material-ui/core/Grid';
import AuthHeader       from '../../../components/AuthHeader';
import AuthForm         from '../../../components/AuthForm/AuthForm';
import Button           from '../../../components/Button';
import Input            from '../../../components/Input';

import useStyles from './styles';


const Login = (props) => {
  const { setChallengeUser, getCurrentUser, setCognitoUser } = props;
  const classes = useStyles();

  const [email, setEmail] = useState({value: '', valid: true});
  const [loginPassword, setLoginPassword] = useState({value: '', valid: true});
  const [rememberMeChecked, setRememberMeChecked] = useState(true);
  const [loading, setLoading] = useState(false);

  let refs = React.useRef({
    email: React.createRef(),
    loginPassword: React.createRef()
  })

  function handleError(error) {
    console.error(error);
    if (typeof props.onError === 'function') {
      props.onError(error);
    }
  }

  async function handleLogin(e) {
    e.preventDefault();

    const invalidFields = FormValidator(refs.current);

    if(invalidFields.length > 0) {
      return handleError(new Error(invalidFields[0].message));
    }

    setLoading(true);
    try {
      let cognitoUser = await Auth.signIn(email.value.toLowerCase(), loginPassword.value)
      if (!rememberMeChecked) {
        window.addEventListener('beforeunload', () => {
          Auth.signOut();
          setCognitoUser();
        });
      }

      if (cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setChallengeUser(cognitoUser);
        props.history.replace('/new-password');
        return;
      }

      await getCurrentUser();
      let userInfo = await Auth.currentUserInfo()
      // The authorizor will pickup that a user has changed and then swap out the current route with dashboard
      await setCognitoUser(userInfo);
    }
    catch(error) {
      if (error.code === 'PasswordResetRequiredException') {
        try {
          await Auth.forgotPassword(email.value.toLowerCase())
          setLoading(false);
          props.history.push(`/reset-password?email=${email.value.toLowerCase()}`);
        } catch (forgotPasswordError) {
          setLoading(false);
          handleError(forgotPasswordError);
        }
      } 
      else if(error.code === "UserNotConfirmedException") {
        setLoading(false);
        props.history.push(`/confirm?email=${email.value.toLowerCase()}`);
      } 
      else {
        setLoading(false);
        handleError(error);
      }
    }
  }

  

  return(
    <AuthForm onSubmit={handleLogin}>

      <AuthHeader />

      <Input
        id='email'
        ref={el => refs.current.email = el}
        errorMessage={"A valid email is required to login"}
        validator={() => validator.isEmail(email.value)}
        marginBottom={16}
        label='Email Address'
        onChange={e => setEmail({value: e.target.value, valid: true})}
        value={email.value}
        error={!email.valid} />
      <Input
        id='loginPassword'
        ref={el => refs.current.loginPassword = el}
        errorMessage={"Password field is required"}
        validator={() => loginPassword.value.length > 0}
        marginBottom={16}
        label='Password'
        type='password'
        onChange={e => setLoginPassword({value: e.target.value, valid: true})}
        value={loginPassword.value}
        error={!loginPassword.valid} />
      <Grid container spacing={0} alignItems="center" justify="flex-start">
        <span className="label">Remember me?</span>
        <Checkbox
          checked={rememberMeChecked}
          onChange={(e) => setRememberMeChecked(e.target.checked)}
          value="remember"
          className="remember-me-checkbox"
        />
      </Grid>

      <input type="submit" style={{ display: 'none' }} />

      <Button
        className={classes.loginButton}
        loading={loading}
        onClick={handleLogin}
        text={"Login"}
        color="primary"
        size="large"
        disabled={loading}
        variant="contained"
        fullWidth={true} />

      <div className={classes.bottomLinks}>
        <Button className={classes.bottomLink} text="Forgot Password" onClick={() => props.history.push("/forgot-password")} />
        {/* <Button className={classes.bottomLink} text="Register New Account" onClick={() => props.history.push("/register")} /> */}
      </div>

    </AuthForm>
  );
}

export default connect(null, { getCurrentUser, setCognitoUser })(Login);